import React from 'react';
import {
    Row,
    Col,
    Button,
    message,
    Input,
    Typography,
    Divider,
    Form
} from 'antd';
import {
    FaSave
} from "react-icons/fa";
import { useMutation } from '@tanstack/react-query';
import axios from '../../../config/axios';

function ResetPassword({ user }) {
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const { mutate, isLoading } = useMutation({
        mutationFn: (data) => {
            axios
                .put(`/auth/resetPassword/${user._id}`, data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'Password has been reset.',
                        duration: 1,
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Something went wrong please check you data or contact Admin.',
                    });
                })
        },
    });

    const onFinish = (values) => {
        mutate(values)
    }

    return (
        <div>
            {contextHolder}
            <Divider />
            <Typography.Title level={5}>
                Reset password
            </Typography.Title>
            <Row>
                <Col xs={24} md={16}>
                    <Form
                        form={form}
                        layout="vertical"
                        name='formResetPassword'
                        onFinish={onFinish}
                        initialValues={user}
                    >
                        <Form.Item
                            name="username"
                            label="Username"
                        >
                            <Input disabled={true} style={{background:"#FFF",color:"#000"}}/>
                        </Form.Item>
                        <Form.Item
                            name="password"
                            label="Password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input data!',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Row justify="end">
                            <Form.Item >
                                <Button type="primary" icon={<FaSave/>} htmlType="submit" disabled={isLoading}>
                                    Save
                                </Button>
                            </Form.Item>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default ResetPassword